import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { RegisterOptions } from 'react-hook-form/dist/types/validator';
import StylishNewInput from '../../DesignSystems/New/StylishNewInput';

type FormTextFieldProps = {
  title: string;
  fieldName: string;
  rules?:
    | { [key: string]: { value: unknown; message: string } }
    | RegisterOptions;
  defaultValue?: string;
  variant?: 'full' | 'half' | 'none';
  disabled?: boolean;
  style?: object;
  placeholder?: string;
};

const FormTextField: React.FC<FormTextFieldProps> = ({
  title,
  fieldName,
  rules,
  defaultValue,
  variant = 'full',
  disabled = false,
  style,
  placeholder,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object' && rules.required.value;

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
      })}
    >
      <label className="form-label">
        {title}
        {required ? (
          <span aria-label="Required field" className="required">
            *
          </span>
        ) : null}
      </label>
      <StylishNewInput
        style={style}
        defaultValue={defaultValue}
        type="text"
        placeholder={placeholder}
        {...register(fieldName, rules)}
        disabled={disabled}
      />
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};
export default FormTextField;
